// Configuração da Aplicação
import type { AppConfig } from '@/types';

function getApiUrl(): string {
  const envValue = import.meta.env.VITE_API_URL;
  const envPort = import.meta.env.VITE_API_PORT;
  const fallbackPort = (envPort || '3001').toString();

  const getDerivedFromBrowserLocation = (): string | null => {
    if (typeof window === 'undefined' || !window.location) return null;
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:${fallbackPort}`;
  };

  const defaultValue = getDerivedFromBrowserLocation() ?? `http://localhost:${fallbackPort}`;
  let finalValue = envValue ?? defaultValue;

  if (typeof window !== 'undefined' && window.location && envValue) {
    const currentHostname = window.location.hostname;
    const isNonLocalClient =
      currentHostname !== 'localhost' && currentHostname !== '127.0.0.1';

    if (isNonLocalClient) {
      try {
        const parsed = new URL(finalValue);
        const isLocalApiHost =
          parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';

        if (isLocalApiHost) {
          parsed.hostname = currentHostname;
          parsed.protocol = window.location.protocol;
          if (!parsed.port) parsed.port = fallbackPort;
          finalValue = parsed.origin;
        }
      } catch {
        // URL inválida; mantém como está
      }
    }
  }

  if (finalValue.endsWith('/api')) {
    finalValue = finalValue.slice(0, -4);
  } else if (finalValue.endsWith('/api/')) {
    finalValue = finalValue.slice(0, -5);
  }
  if (finalValue.endsWith('/')) {
    finalValue = finalValue.slice(0, -1);
  }

  return finalValue;
}

export const appConfig: AppConfig = {
  name: import.meta.env.VITE_APP_NAME ?? 'Tutoriais Lukos',
  version: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
  description: import.meta.env.VITE_APP_DESCRIPTION ?? 'Plataforma de tutoriais do sistema Lukos',
  apiUrl: getApiUrl(),
  devMode: import.meta.env.DEV,
  useMockData: import.meta.env.VITE_USE_MOCK_DATA === 'true',
  maxFileSize: parseInt(import.meta.env.VITE_MAX_FILE_SIZE ?? '10', 10) * 1024 * 1024,
  allowedFileTypes: (import.meta.env.VITE_ALLOWED_FILE_TYPES ?? 'image/jpeg,image/png,image/gif,video/mp4,video/webm').split(','),
  requestTimeout: parseInt(import.meta.env.VITE_REQUEST_TIMEOUT ?? '10000', 10),
  maxRetryAttempts: parseInt(import.meta.env.VITE_MAX_RETRY_ATTEMPTS ?? '3', 10),
};

export default appConfig;
